import { exportDoctorNotesToPDF } from "@src/helpers/constants";
import {
  getSubject,
  getSubjectNoteList,
  SubjectDoctorLog,
} from "@src/redux";
import React from "react";
import { useTranslation } from "react-i18next";
import { PiExportBold } from "react-icons/pi";
import { useSelector } from "react-redux";

type Props = {};

const DockerLogHeader = (props: Props) => {
  const { t } = useTranslation();
  const { result: subjectResult } = useSelector(getSubject);
  const { result: doctorLog, loading } = useSelector(getSubjectNoteList);
  const handleExportDoctorNotes = () => {
    let subject = subjectResult || {};
    exportDoctorNotesToPDF(doctorLog?.items || [], subject, "", ",", "");
  };
  return (
    <div className="doctor-log-header-container">
      {t("notes")}{" "}
      <PiExportBold
        color="#8a174c"
        className="doctor-log-export-icon"
        onClick={handleExportDoctorNotes}
      />
    </div>
  );
};

export default DockerLogHeader;
